var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Profileinfo } from "./Profileinfo";
import "@frameworks/salesjourney/stylesheets/components/Features/ProfilePage/Profile.scss";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import RatingsBlock from "./Ratings/RatingsBlock";
import ProfileAccordionTable from "./ProfileAccordionTable/ProfileAccordionTable";
import di from "../di/serviceLocator";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
export var criticalColumns = [
    { columnName: "Critical Activities", key: "criticalLevel" },
    { columnName: "Sub cat ", key: "subCategoryName" },
    { columnName: "Count of Lead", key: "leadCount" },
];
export var ProfilePage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var navigate = useNavigate();
    var _t = __read(React.useState(false), 2), summarizeToggle = _t[0], setSummarizeToggle = _t[1];
    var criticalColums = [
        { columnName: "Critical Activities", key: "criticalLevel" },
        { columnName: "Scheme ", key: "displayName" },
        {
            columnName: "Count of Lead",
            keysForCustomFunction: ["leadCount", "subCategoryId", "displayNameId"],
            tdCustomFunction: function (keysForCustomFunction) {
                return (React.createElement("div", { className: "hand_cursor", onClick: function () {
                        var filterData = {};
                        // filterData.scheme = [parseInt(keysForCustomFunction[1])];
                        filterData.displayId = [parseInt(keysForCustomFunction[2])];
                        navigate("/dashboard/lead-dashboard?filterData=" +
                            encodeURI(JSON.stringify(filterData)) +
                            "&isDateSkip=" +
                            true +
                            "&tabFlag=" +
                            0, { replace: true });
                    } }, keysForCustomFunction[0]));
            },
        },
    ];
    var getProfileDetails = function () {
        di.profile.getProfileDetails();
    };
    var profileData = useSelector(function (state) { return state.Profile.ProfileDetails.reducersData.data; });
    React.useEffect(function () {
        getProfileDetails();
        getCreaticalActivity();
        // getClientRatingSummery();
    }, []);
    var getCreaticalActivity = function () {
        di.profile.getCreaticalActivity();
    };
    var creaticalActivity = useSelector(function (state) { return state.Profile.CreaticalActivityReducer.data; });
    var getClientRatingSummery = function () {
        var clientRatingSummaryRequestPayload = {
            pageno: "1",
            pageSize: "100",
        };
        di.profile.updateClientRatingSummary(clientRatingSummaryRequestPayload);
    };
    return (React.createElement(GridContainer, { parentClass: "profile-page-conatiner px-0" },
        React.createElement(Profileinfo, { profilename: (_a = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _a === void 0 ? void 0 : _a.empName, address: (_b = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _b === void 0 ? void 0 : _b.empAddress, linkedIn: (_c = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _c === void 0 ? void 0 : _c.linkedInId, fB: (_d = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _d === void 0 ? void 0 : _d.facebookId, twitter: (_e = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _e === void 0 ? void 0 : _e.twitterId, agreementTypeName: (_f = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _f === void 0 ? void 0 : _f.agreement_type_name, data: [
                {
                    title: "Mobile",
                    value: ((_g = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _g === void 0 ? void 0 : _g.empMobNo) || "-",
                },
                {
                    title: "Email",
                    value: ((_h = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _h === void 0 ? void 0 : _h.empEmail) || "-",
                },
                {
                    title: "Branch",
                    value: ((_j = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _j === void 0 ? void 0 : _j.empBranch) || "-",
                },
                {
                    title: "Location",
                    value: ((_k = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _k === void 0 ? void 0 : _k.empLocation) || "-",
                },
                { title: "Zone", value: ((_l = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _l === void 0 ? void 0 : _l.empZone) || "-" },
                {
                    title: "".concat(loginDI.login.getIsRMPartnerFRM().isPartner ? "FRM" : "RA", " "),
                    value: ((_m = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _m === void 0 ? void 0 : _m.ra) || "-",
                },
                { title: "BH", value: ((_o = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _o === void 0 ? void 0 : _o.bh) || "-" },
                { title: "RH", value: ((_p = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _p === void 0 ? void 0 : _p.rh) || "-" },
                { title: "ZH", value: ((_q = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _q === void 0 ? void 0 : _q.zh) || "-" },
                { title: "ASM", value: ((_r = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _r === void 0 ? void 0 : _r.asm) || "-" },
                { title: "RH2", value: ((_s = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _s === void 0 ? void 0 : _s.rH2) || "-" },
            ] }),
        React.createElement(RatingsBlock, null),
        React.createElement(ProfileAccordionTable, null)));
};
